// @flow
import firestore from '../services/firestore';
import configSchema from '../../server/shared/schemas/config';

export default configSchema(firestore);